/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnforcementNotificationMessageKeyEnum = 'VcdrOrgEnforcementGraceVmOverage' | 'VcdrOrgEnforcementGraceTibOverage' | 'VcdrOrgEnforcementDegradedVmOverage' | 'VcdrOrgEnforcementDegradedTibOverage' | 'VcdrOrgEnforcementSuspendedVmOverage' | 'VcdrOrgEnforcementSuspendedTibOverage' | 'VcdrOrgEnforcementGraceNonSubscription' | 'VcdrOrgEnforcementSuspendedNonSubscription' | 'VmcfsOrgEnforcementGraceTibOverage' | 'VmcfsOrgEnforcementDegradedTibOverage' | 'VmcfsOrgEnforcementSuspendedTibOverage' | 'VmcfsOrgEnforcementGraceNonSubscription' | 'VmcfsOrgEnforcementSuspendedNonSubscription' | 'DefaultOrgEnforcementMessageKey';

export const EnforcementNotificationMessageKeyEnum = {

    VCDR_ORG_ENFORCEMENT_GRACE_VM_OVERAGE: 'VcdrOrgEnforcementGraceVmOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_GRACE_TIB_OVERAGE: 'VcdrOrgEnforcementGraceTibOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_DEGRADED_VM_OVERAGE: 'VcdrOrgEnforcementDegradedVmOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_DEGRADED_TIB_OVERAGE: 'VcdrOrgEnforcementDegradedTibOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_SUSPENDED_VM_OVERAGE: 'VcdrOrgEnforcementSuspendedVmOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_SUSPENDED_TIB_OVERAGE: 'VcdrOrgEnforcementSuspendedTibOverage' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_GRACE_NON_SUBSCRIPTION: 'VcdrOrgEnforcementGraceNonSubscription' as EnforcementNotificationMessageKeyEnum,

    VCDR_ORG_ENFORCEMENT_SUSPENDED_NON_SUBSCRIPTION: 'VcdrOrgEnforcementSuspendedNonSubscription' as EnforcementNotificationMessageKeyEnum,

    VMCFS_ORG_ENFORCEMENT_GRACE_TIB_OVERAGE: 'VmcfsOrgEnforcementGraceTibOverage' as EnforcementNotificationMessageKeyEnum,

    VMCFS_ORG_ENFORCEMENT_DEGRADED_TIB_OVERAGE: 'VmcfsOrgEnforcementDegradedTibOverage' as EnforcementNotificationMessageKeyEnum,

    VMCFS_ORG_ENFORCEMENT_SUSPENDED_TIB_OVERAGE: 'VmcfsOrgEnforcementSuspendedTibOverage' as EnforcementNotificationMessageKeyEnum,

    VMCFS_ORG_ENFORCEMENT_GRACE_NON_SUBSCRIPTION: 'VmcfsOrgEnforcementGraceNonSubscription' as EnforcementNotificationMessageKeyEnum,

    VMCFS_ORG_ENFORCEMENT_SUSPENDED_NON_SUBSCRIPTION: 'VmcfsOrgEnforcementSuspendedNonSubscription' as EnforcementNotificationMessageKeyEnum,

    DEFAULT_ORG_ENFORCEMENT_MESSAGE_KEY: 'DefaultOrgEnforcementMessageKey' as EnforcementNotificationMessageKeyEnum
};

